import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { type } from 'os';
import { createFalse } from 'typescript';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { Platform } from '@angular/cdk/platform';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderOptions, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
let k=1,j=90;
@Component({
  selector: 'app-create-cust-item',
  templateUrl: './create-cust-item.component.html',
  styleUrls: ['./create-cust-item.component.scss'],
})
export class CreateCustItemComponent  {
  makeName;
  buttonObj:any=[{name:"Individual House",flat:false,id:1},
  {name:"Flat",flat:true,id:2}]
  flatType = this.buttonObj[0].id;
  appt:boolean = this.buttonObj[0].flat;
  type;
  size;
  time;
  slots;
  dateFormat;
  minDate = new Date();
  purchasedate:any;
  loader: boolean = true;
  addressInd: boolean = true;
  editBool:boolean=false;
  activeInd: boolean = true;
  subItemsType;
  item:any;
  fontStyle;
  identificationNo;
  id;
  modelName;
  modelId;
  modelObj:any=[];
  makeId;
  makeObj:any = [];
  pic;
  cloneUsers:any=[];
  custName;
  category;
categoryName;
categoryId;
categoryCode;
typeObj;
typeName;
typeId;
userId;
url;
Oid;users;
contactNbrMob;
itemCategoryId;
itemCategory;
max;
min = 1900; 
colour;
img;
doorNbr;
street;
flatNo;
flatName;
subType;
itemTypeId;
optionName;
  optionId;
  carService:boolean=false;
  pricing:boolean=false;
  homeCleaning:boolean=false;
typeCode;
fridgeWashing;
acService;
capacity;
area;
  constructor(private service: ApiService,public handler: HandlerService,public router: Router,public translate: TranslateService,
    public auth: AuthService,  public location: LocationService,   public bottomSheet: MatBottomSheet,  private platform:Platform,
    private loc: Geolocation,
    private geoCoder:NativeGeocoder) { }

  ionViewWillEnter() {
    this.max = this.minDate.getFullYear();
    let url = window.location.href;  
    if(url.includes('customerItem')){
      this.userId=localStorage.getItem('vendorcustId')    
    }else{
      this.userId=sessionStorage.getItem('customerId')
   
    }
  
    this.dateFormat = this.auth.getDateformat();
    this.loader=true;
    this.url=window.location.href
    this.itemCategory1();
      this.itemType();
      this.itemSubType(); 
      this.getUsers();
    if(this.url.includes('edit')) {
      this.editBool=true;
      this.id= window.location.href.split('/').pop();        
      this.service.custItemById(this.id).subscribe((res:any)=>{
        this.item=res;     
        this.loader = false;
        this.addressInd=false;
          this.makeName = this.item.make;
          this.modelName = this.item.model;
          this.activeInd = this.item.activeInd;
          this.identificationNo=this.item.identificationNo;
          this.custName=this.item.custName;  
          this.contactNbrMob=this.item.contactNbrMob;
          this.location.street=this.item.street;
          this.location.stateId=this.item.stateId;
          this.location.regionId=this.item.regionId;
          this.location.cityId=this.item.cityId;
          this.location.zipcode=this.item.zipcode;
          this.purchasedate=this.item.purchaseDate;
          this.type = this.item.type;
          this.colour = this.item.colour;
          this.img = this.item.img;
          this.appt=this.item.appt;
       
          if(!this.appt){
            this.flatType = 1;
          }else{
            this.flatType = 2;
          }
          this.doorNbr=this.item.doorNbr;
          this.flatName=this.item.flatName;
       
          this.flatNo=this.item.flatNo;
          this.itemCategory = this.item.itemCategoryId;
          setTimeout(() => {
            this.category.map(res1 => {
              if (res1.id == this.itemCategory) {
                this.categoryName = res1.name;
                this.categoryId = res1.id;
                this.categoryCode = res1.code;
                if(this.categoryCode=="CAR"){
            this.carService=true;
          }else{
            this.carService=false;
          }
          if(this.categoryCode =="PSC" || this.categoryCode =="HC" ){              
            this.pricing=true;
            this.homeCleaning=true;
            
          } else{
            this.pricing=false;
            this.homeCleaning=false;
          }
              }
            })
          }, 1000);
          setTimeout(() => {
            this.typeObj.map(res1 => {
              if (res1.id == this.type) {

                this.typeName = res1.name;
                this.typeId = res1.id;
              }
            })
          }, 1000);
      })
      err=>{
        this.handler.err(err);
        this.loader=false;
      }
    }
    else{
      this.editBool = false;
      this.loader=false;
    } 
          }

  itemCategory1(){
    this.service.getOrgCategory().subscribe(res=>{
      this.category = res;
      })
  }

   itemType(){
    this.service.getItemType().subscribe(res=>{
      this.typeObj = res;   
    })
  }

  cancel(){
    if(this.url.includes('cust-item-create') || this.url.includes('cust-item-edit') ){
      this.router.navigate(['viewItems/',+this.userId])  
    }else{
      this.router.navigate(['custItem/',+this.userId])  
    }
   
  }
  getUsers(){
    this.service.getUserById(this.userId).subscribe(res => {
      this.loader=false;
      this.users = res;
      // this.users = this.users.filter(res =>{return res.userId == this.userId})
      this.custName = this.users.firstName;
      this.contactNbrMob = this.users.contactNbrMob;
      if(this.users.addresses[0] && !this.url.includes('edit') ){
        this.location.regionId=this.users.addresses[0].regionId;
        this.location.street=this.users.addresses[0].street;
        this.location.stateId=this.users.addresses[0].stateId;
        this.location.cityId=this.users.addresses[0].cityId;
        this.location.zipcode=this.users.addresses[0].zipcode;
        this.appt=this.users.addresses[0].appt;
        if(!this.appt){
          this.flatType = 1;
        }else{
          this.flatType = 2;
        }
        this.doorNbr=this.users.addresses[0].doorNbr;
        this.flatName=this.users.addresses[0].flatName;   
        this.flatNo=this.users.addresses[0].flatNo;
      }
  
       },err=>{
        this.handler.err(err)
        this.loader = false;
      })
  }
 
returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let year = data.getFullYear();
    return year;
  }

  handleFile(files) {
    if(files[0].size < 1048576){
      var img = new Image();
      img.src = URL.createObjectURL(files[0]);
      img.onload = (data) => {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        this.img = canvas.toDataURL('image/jpeg', 0.07);
      }
    }else{
      this.handler.res('Image Size Should Not Exceeds 1mb ');
    }
    
}

togData(data){
if(this.addressInd){
  if(this.users.addresses[0] ){
    this.location.regionId=this.users.addresses[0].regionId;
    this.location.street=this.users.addresses[0].street;
    this.location.stateId=this.users.addresses[0].stateId;
    this.location.cityId=this.users.addresses[0].cityId;
    this.location.zipcode=this.users.addresses[0].zipcode;
    this.appt=this.users.addresses[0].appt;
    if(!this.appt){
      this.flatType = 1;
    }else{
      this.flatType = 2;
    }
    this.doorNbr=this.users.addresses[0].doorNbr;
    this.flatName=this.users.addresses[0].flatName;   
    this.flatNo=this.users.addresses[0].flatNo;
  }
}
if(!this.addressInd){
  this.location.street="";
  this.location.stateId="";
  this.location.regionId="";
  this.location.zipcode="";
  this.location.cityId="";
  this.location.houseNbr="";
  this.doorNbr="";
  this.flatNo="";
  this.flatName="";
  this.flatType = this.buttonObj[0].id;
  this.appt = false

}
// if(!this.addressInd && this.url.includes('edit')){
//   this.location.street=this.item.street;
//   this.location.stateId=this.item.stateId;
//   this.location.regionId=this.item.regionId;
//   this.location.cityId=this.item.cityId;
//   this.location.zipcode=this.item.zipcode;
//   this.appt=this.item.appt;
//   if(!this.appt){
//     this.flatType = 1;
//   }else{
//     this.flatType = 2;
//   }
//   this.doorNbr=this.item.doorNbr;
//   this.flatName=this.item.flatName;   
//   this.flatNo=this.item.flatNo;
// }
}


    create() {
      this.loader = true;
      var post={
        "make": this.makeName,
        "model": this.modelName,
        "type": this.typeId,    
        "purchaseDate":this.purchasedate,
        "custName":this.custName,
        "contactNbrMob":this.contactNbrMob,
        "itemCategoryId":this.categoryId,
        "userId":this.userId,
        "identificationNo":this.identificationNo,
        "activeInd": true,
        "colour":this.colour,
        "img":this.img,
        "appt":this.appt,
        "houseNbr": this.location.houseNbr,
        "cityId": this.location.cityId,
        "stateId": this.location.stateId,
        "regionId":this.location.regionId,
        "zipcode":this.location.zipcode,
        "lat": this.location.lat,
        "lon": this.location.lon,
        "subItemTypeId":this.optionId,
      "capacity":this.capacity,
      "area":this.area,
      } 
      if(!this.appt){
        Object.assign(post,{"doorNbr":this.doorNbr,"street": this.location.street})
      }else{
        Object.assign(post,{"flatNo":this.flatNo, "flatName":this.flatName,})
      }
      this.service.custItem(post).subscribe(res=>{
        this.handler.res("Customer Item Created Successfully");
        this.loader = false;
        this.makeName=undefined;
        if(this.url.includes('cust-item-create')){
          this.router.navigate(['viewItems/',+this.userId])  
        }else{
          this.router.navigate(['custItem/',+this.userId])  
        }
     
      },
      err=>{
        this.loader=false;
        this.handler.err(err);
      })
    }
    editCustItem() {   
        this.loader = true;
      if (this.makeName) {
        this.makeName = this.makeName.toUpperCase();
      }
      this.item.make=this.makeName;
      this.item.model=this.modelName;
      this.item.type=this.typeId;
      this.item.activeInd = this.activeInd;
      this.item.identificationNo= this.identificationNo;
      this.item.custName=this.custName;
      this.item.userId=this.userId;
      this.item.purchaseDate = this.purchasedate;
      this.item.itemCategoryId = this.categoryId;
      this.item.colour = this.colour;
      this.item.img = this.img;
      this.item.stateId = this.location.stateId;
      this.item.cityId = this.location.cityId;
      this.item.regionId = this.location.regionId;
      this.item.street = this.location.street;
      this.item.zipcode = this.location.zipcode;
      this.item.appt= this.appt;
      this.item.doorNbr=this.doorNbr;
      this.item.flatName=this.flatName;
      this.item.flatNo=this.flatNo;
      this.service.updatecustItem(this.id,this.item).subscribe(res=>{
        this.handler.res("Customer Item  Updated Successfully");
        this.loader = false;
        if(this.url.includes('cust-item-edit')){
          this.router.navigate(['viewItems/',+this.userId])  
        }else{
          this.router.navigate(['custItem/',+this.userId])  
        }
  
      },
      err=>{
        this.loader=false;
        this.handler.err(err);
  
      })
      
     
    }

    returnDate1(data) {
      let date = data.getDate();
      date = date < 10 ? '0' + date : date;
      let month = data.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let year = data.getFullYear();
      return year + '-' + month + '-' + date;
    }
  
    ionViewWillLeave(){
        this.makeName='';
        this.modelName='';
        this.type='';
        this.custName='';
        this.typeName='';
        this.categoryName='';
        this.purchasedate='';
        this.location.pop=false;
        this.location.newSearch="";
       
    }

    popClose(){
      this.location.pop=false;
      this.location.newSearch="";
      this.location.dummy = false;
    }

    clearTime() {
      this.time = 'Time';
      this.slots = [];
   }

  //  getUser(val) { 
  //   let x = val.length;
  //   if(x > 0){
  //     this.service.searchCustomers("CUST",val,this.Oid).subscribe((res: any) => {
  //       this.cloneUsers =JSON.parse(JSON.stringify(res)); 
  //     })
  //   }
  //   }

    openBottomSheet(): void {
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.category,
      });
      dialogRef.afterDismissed().subscribe((res:any) => {
        if(res){
          this.categoryName = res.name;
          this.categoryId=res.id;
          this.categoryCode = res.code;
          if(this.categoryCode=="CAR"){
            this.carService=true;
            this.getCustMake();
          }else{
            this.carService=false;
          }
          if(this.categoryCode =="PSC" || this.categoryCode =="HC" ){              
            this.pricing=true;
            this.homeCleaning=true;
            
          } else{
            this.pricing=false;
            this.homeCleaning=false;
          }
          this.typeName="";
          this.typeId="";
        }
      });
    }

    openBottomSheet1(): void {
         let x = this.typeObj.filter(res => res.itemCategory == this.categoryId ); 
        const dialogRef = this.bottomSheet.open(BottomSheet,{
          data: x,
        });
        dialogRef.afterDismissed().subscribe((res:any) => {
          if(res){
            this.typeName = res.name;
            this.typeId=res.id;
            this.typeCode= res.code;
            if(this.typeCode=="AC"){
              this.fridgeWashing=true;
              this.acService=true;
            }   
            if(this.typeCode=="RF" || this.typeCode=="WM"){
              this.fridgeWashing=true;
            } 
          }
        });
      
    }
    getAppt(id){
      this.appt = id;
    }

        
    onInput() {
      this.location.autoComplete();
    }

    openBottomSheetsubType(): void{ 
     const dialogRef = this.bottomSheet.open(BottomSheet, {
       data:this.subType,
     });
     dialogRef.afterDismissed().subscribe((res) => {
       this.optionName = res.name;
       this.optionId = res.id;

       });
    }

     itemSubType(){
    this.service.getSubItemType().subscribe(res=>{
      this.subType=res;
     
    })
  }
  openLocation(){
    this.location.lat="";
    this.location.lon="";
     this.location.zipcode="";
     this.location.street="";
     this.location.stateId="";
     this.location.cityId="";
     this.location.regionId="";
    this.setLoc();  
    this.location.pop = false;
  }

  setLoc(){
    if(this.platform.ANDROID || this.platform.IOS){
        let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
      this.loc.getCurrentPosition().then(res => {
        this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
            let x: any = result;
            localStorage.setItem('location', JSON.stringify(x));
            let loc;
            loc=JSON.parse(localStorage.getItem('location'));
            this.location.lat=loc[0].latitude;
            this.location.lon=loc[0].longitude;
             this.location.zipcode=loc[0].postalCode;
             this.location.street=loc[0].thoroughfare;
             this.location.stateId=loc[0].administrativeArea;
             this.location.cityId=loc[0].locality;    
             this.location.regionId=loc[0].subLocality;       
        })        
    })
 }   
}
getCustMake(){
  this.modelName = "" ;
  this.modelId="";
  this.service.getMake(this.categoryId).subscribe((res:any)=>{
    if(res){
      this.makeObj = res;
      console.log(this.makeObj)
    }
  },err=>{
    this.handler.err(err)
  })
}

getCustModel(){
  this.service.getModel(this.categoryId,this.makeId).subscribe((res:any)=>{
  this.modelObj = res;    
  
  },
  err=>{
       this.handler.err(err);

  })
}

openBottomSheetMake(): void {    
  const dialogRef = this.bottomSheet.open(BottomSheet,{
    data: this.makeObj,
  });
  dialogRef.afterDismissed().subscribe((res:any) => {
    if(res){
      this.makeName = res.name;
      console.log(this.makeName)
      this.makeId=res.id; 
      if(this.makeId){
        this.getCustModel();
      }  
      }        
  });
}

openBottomSheetModel():void {    
  const dialogRef = this.bottomSheet.open(BottomSheet,{
    data: this.modelObj,
  });
  dialogRef.afterDismissed().subscribe((res:any) => {
    if(res){
      this.modelName = res.name;
      this.modelId=res.id;     
      }        
  });
}
}
